import { render, staticRenderFns } from "./precisePost.vue?vue&type=template&id=14669752&scoped=true&"
import script from "./precisePost.vue?vue&type=script&lang=js&"
export * from "./precisePost.vue?vue&type=script&lang=js&"
import style0 from "./precisePost.vue?vue&type=style&index=0&id=14669752&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14669752",
  null
  
)

export default component.exports